// // src/pages/me/negotiations/[id]/index.js - Using your working component with tabs
// import React, { useEffect, useState } from "react";
// import io from "socket.io-client";
// import NegotiationChatContainer from "../components/NegotiationChatContainer";
// import { api_url } from "../../../../constant";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import Client from "../../../../utils/client";
// import { getUnits } from "../../../../api";
// import { useQuery } from "@tanstack/react-query";
// import InvoiceModal from "../components/InvoiceModal";
// import { toast } from "react-toastify";
// import NegotiationInvoices from "../components/NegotiationInvoices";
// import NegotiationOrder from "../components/NegotiationOrder";

// function NegotiationDetails() {
//     const { id } = useParams();
//     const [messages, setMessages] = useState([]);
//     const [negotiation, setNegotiation] = useState(null);
//     const [invoices, setInvoices] = useState([]);
//     const [orders, setOrders] = useState([]); // Changed from order to orders
//     const [newMessage, setNewMessage] = useState("");
//     const [sending, setSending] = useState(false);
//     const [activeTab, setActiveTab] = useState('chat');
//     const socket = React.useRef(null);
//     const currentUserId = localStorage.getItem("user_id");
//     const [showInvoiceModal, setShowInvoiceModal] = useState(false);
//     const [invoiceDetails, setInvoiceDetails] = useState({
//         quantity: "",
//         amount: "",
//         dueDate: "",
//         notes: "",
//         deliveryPlace: "",
//         unitId: "",
//         deliveryResponsibility: "seller",
//         paymentTerms: "",
//     });
//     const [token, setToken] = useState(null);

//     const { data: units } = useQuery({
//         queryKey: ["units"],
//         queryFn: () => getUnits(),
//         cacheTime: 99999,
//         staleTime: 99999,
//     });

//     useEffect(() => {
//         const storedToken = localStorage.getItem("token")?.replace(/"/g, '');
//         if (storedToken) {
//             setToken(storedToken);
//         }
//     }, []);

//     // Fetch invoices and orders
//     useEffect(() => {
//         if (!id || !token) return;

//         const fetchInvoicesAndOrders = async () => {
//             try {
//                 // Fetch invoices
//                 const response = await axios.get(`${api_url}/invoices`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 const negotiationInvoices = response.data.filter(
//                     invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
//                 );
//                 setInvoices(negotiationInvoices);

//                 // Fetch orders for this negotiation
//                 // Get all orders for the user
//                 const ordersRes = await axios.get(`${api_url}/orders?type=buyer`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
                
//                 // Filter orders that belong to this negotiation
//                 const negotiationOrders = ordersRes.data.filter(
//                     order => order.negotiation?.id === parseInt(id) || order.negotiationId === parseInt(id)
//                 );
//                 setOrders(negotiationOrders);

//             } catch (error) {
//                 console.error("Failed to fetch invoices/orders:", error.message);
//             }
//         };

//         fetchInvoicesAndOrders();
//     }, [id, token]);

//     // Main negotiation and chat setup - KEPT EXACTLY THE SAME
//     useEffect(() => {
//         if (!id) {
//             console.error("Negotiation ID is missing");
//             return;
//         }

//         const fetchNegotiation = async () => {
//             try {
//                 const response = await axios.get(`${api_url}/negotiations/${id}`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 setNegotiation(response.data);
//             } catch (error) {
//                 console.error("Failed to fetch Negotiation:", error.message);
//             }
//         };

//         const fetchMessages = async () => {
//             try {
//                 const response = await axios.get(`${api_url}/negotiations/${id}/messages`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 setMessages(response.data);
//             } catch (error) {
//                 console.error("Failed to fetch messages:", error.message);
//             }
//         };

//         const markMessagesAsRead = async () => {
//             try {
//                 await Client.post(`${api_url}/messages/mark-seen/${id}`, {}, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//             } catch (error) {
//                 console.error("Failed to mark messages as read:", error.message);
//             }
//         };

//         const IntializeSocketConnection = async () => {
//             try {
//                 const freshToken = localStorage.getItem("token")?.replace(/"/g, '');
//                 if (!freshToken) {
//                     console.error("Socket setup failed: token is missing");
//                     return;
//                 }
//                 socket.current = io(`${api_url}/messages?negotiationId=${id}`, {
//                     extraHeaders: {
//                         Authorization: `Bearer ${freshToken}`,
//                     },
//                 });

//                 socket.current.emit("joinRoom", `room-${id}`);

//                 socket.current.on("newMessage", (message) => {
//                     setMessages((prev) => [...prev, message]);
//                 });

//                 socket.current.on("error", (errorMessage) => {
//                     toast.error(errorMessage, {
//                         position: "top-center",
//                         autoClose: 5000,
//                         hideProgressBar: false,
//                         closeOnClick: true,
//                         pauseOnHover: true,
//                         draggable: true,
//                     });
//                 });
//             } catch (error) {
//                 console.error("Failed to initialize socket:", error.message);
//             }
//         };

//         fetchNegotiation();
//         fetchMessages();
//         markMessagesAsRead();
//         IntializeSocketConnection();

//         return () => {
//             if (socket.current) {
//                 socket.current.disconnect();
//             }
//         };
//     }, [id, token]);

//     const sendMessage = () => {
//         if (newMessage.trim()) {
//             setSending(true);

//             socket.current.emit(
//                 "sendMessage",
//                 JSON.stringify({
//                     negotiationId: parseInt(id, 10),
//                     content: newMessage,
//                 })
//             );

//             setNewMessage("");
//             setSending(false);
//         }
//     };

//     const handleInvoiceChange = (e) => {
//         const { name, value } = e.target;
//         setInvoiceDetails((prev) => ({
//             ...prev,
//             [name]: name === "quantity" || name === "amount" ? Number(value) : value,
//         }));
//     };

//     const handleIssueInvoice = () => {
//         setShowInvoiceModal(true);
//     };

//     const submitInvoice = async () => {
//         try {
//             const token = localStorage.getItem("token");

//             const formattedNegotiationId = Number(id);
//             const formattedQuantity = Number(invoiceDetails.quantity);
//             const formattedAmount = Number(invoiceDetails.amount);
//             const formattedUnitId = Number(invoiceDetails.unitId);

//             if (isNaN(formattedNegotiationId) || isNaN(formattedQuantity) || isNaN(formattedAmount)) {
//                 toast.error("البيانات المدخلة غير صحيحة. يرجى التحقق من جميع الحقول المطلوبة.");
//                 return;
//             }

//             const checkResponse = await axios.get(`${api_url}/invoices/${formattedNegotiationId}/pending`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });

//             if (checkResponse.data.hasPendingInvoice) {
//                 toast.error("توجد فاتورة قيد الانتظار لهذا التفاوض.");
//                 return;
//             }

//             await axios.post(
//                 `${api_url}/invoices`,
//                 {
//                     negotiationId: formattedNegotiationId,
//                     quantity: invoiceDetails.quantity,
//                     amount: formattedAmount,
//                     dueDate: invoiceDetails.dueDate,
//                     notes: invoiceDetails.notes,
//                     deliveryPlace: invoiceDetails.deliveryPlace,
//                     unitId: formattedUnitId,
//                     deliveryResponsibility: invoiceDetails.deliveryResponsibility,
//                     paymentTerms: invoiceDetails.paymentTerms,
//                 },
//                 {
//                     headers: { Authorization: `Bearer ${token}` },
//                 }
//             );

//             toast.success("تم إصدار الفاتورة بنجاح!");
//             setShowInvoiceModal(false);

//             // Refresh invoices and orders
//             const invoicesRes = await axios.get(`${api_url}/invoices`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             const negotiationInvoices = invoicesRes.data.filter(
//                 invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
//             );
//             setInvoices(negotiationInvoices);

//             // Also refresh orders
//             const ordersRes = await axios.get(`${api_url}/orders?type=buyer`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             const negotiationOrders = ordersRes.data.filter(
//                 order => order.negotiation?.id === parseInt(id) || order.negotiationId === parseInt(id)
//             );
//             setOrders(negotiationOrders);

//         } catch (error) {
//             console.error("Failed to submit invoice:", error.response?.data || error.message);
//             toast.error("فشل في إصدار الفاتورة");
//         }
//     };

//     const handleInvoiceAccepted = async () => {
//         const invoicesRes = await axios.get(`${api_url}/invoices`, {
//             headers: { Authorization: `Bearer ${token}` },
//         });
//         const negotiationInvoices = invoicesRes.data.filter(
//             invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
//         );
//         setInvoices(negotiationInvoices);

//         // Refresh orders after invoice acceptance
//         const ordersRes = await axios.get(`${api_url}/orders?type=buyer`, {
//             headers: { Authorization: `Bearer ${token}` },
//         });
//         const negotiationOrders = ordersRes.data.filter(
//             order => order.negotiation?.id === parseInt(id) || order.negotiationId === parseInt(id)
//         );
//         setOrders(negotiationOrders);
//     };

//     if (!negotiation) {
//         return (
//             <div className="flex justify-center items-center h-96">
//                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
//             </div>
//         );
//     }

//     const isSeller = currentUserId === negotiation?.sellerId;
//     const hasPendingInvoice = invoices.some(inv => inv.status === 'pending');
//     const hasOrders = orders.length > 0; // Check if there are any orders

//     return (
//         <div className="w-full h-full relative mt-10">
//             <div className="mx-auto text-center lg:w-[66%] lg:border-2 border-primary rounded-2xl py-4 px-6 lg:px-10 bg-white">
//                 {/* Header */}
//                 <div className="lg:pb-6 pb-4 flex-wrap flex gap-4 items-center justify-center lg:justify-between border-b-2 border-primary">
//                     {currentUserId === negotiation?.sellerId && !hasPendingInvoice && !hasOrders && (
//                         <button
//                             onClick={handleIssueInvoice}
//                             className="bg-primary text-white p-2 px-3 font-bold text-sm rounded-lg hover:scale-105 transition cursor-pointer"
//                         >
//                             إصدار فاتورة
//                         </button>
//                     )}

//                     {negotiation?.itemName ? (
//                         <p className="text-2xl font-bold md:block hidden">
//                             طلب&nbsp;
//                             {negotiation.type === "SERVICE" ? "" : (`${negotiation.quantity} `)}
//                             {negotiation.itemUnit}&nbsp;
//                             - &nbsp;
//                             {negotiation.itemName}
//                         </p>
//                     ) : (
//                         <p>تحميل...</p>
//                     )}

//                     <div className="flex justify-center lg:justify-end items-center gap-1">
//                         <span className="relative font-bold text-sm rounded-lg px-4 py-2 shadow-lg shadow-green-500/30 border border-primary flex items-center gap-2">
//                             <span className="w-3 h-3 rounded-full bg-green-500 shadow-lg shadow-green-500/30"></span>
//                             {currentUserId === negotiation?.buyerId ? (
//                                 negotiation?.seller?.name || 'Seller'
//                             ) : (
//                                 negotiation?.buyer?.name || 'Buyer'
//                             )}
//                         </span>
//                     </div>
//                 </div>

//                 {/* Tabs */}
//                 <div className="flex gap-4 mt-4 border-b">
//                     <button
//                         onClick={() => setActiveTab('chat')}
//                         className={`py-2 px-4 font-medium transition-all ${activeTab === 'chat'
//                                 ? 'border-b-2 border-primary text-primary'
//                                 : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                     >
//                         💬 المحادثة
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('invoices')}
//                         className={`py-2 px-4 font-medium transition-all ${activeTab === 'invoices'
//                                 ? 'border-b-2 border-primary text-primary'
//                                 : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                     >
//                         📄 الفواتير ({invoices.length})
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('order')}
//                         disabled={!hasOrders}
//                         className={`py-2 px-4 font-medium transition-all ${!hasOrders ? 'opacity-50 cursor-not-allowed' : ''
//                             } ${activeTab === 'order'
//                                 ? 'border-b-2 border-primary text-primary'
//                                 : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                     >
//                         📦 الطلب {hasOrders ? `(${orders.length})` : ''}
//                     </button>
//                 </div>

//                 {/* Chat Tab */}
//                 {activeTab === 'chat' && (
//                     <>
//                         <NegotiationChatContainer
//                             messages={messages}
//                             currentUserId={currentUserId}
//                             negotiation={negotiation} />
//                         <div className="relative w-full">
//                             <div className="h-16 border border-primary rounded-2xl flex items-center px-3 lg:px-6 bg-white">
//                                 <button
//                                     onClick={sendMessage}
//                                     disabled={sending || !newMessage}
//                                     className={`
//                                         flex items-center justify-center px-4 py-2 text-white font-bold text-lg
//                                         rounded-xl transition-all duration-200
//                                         ${sending || !newMessage ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary hover:bg-primary-dark'}
//                                     `}
//                                 >
//                                     إرسال
//                                 </button>
//                                 <input
//                                     type="text"
//                                     dir="rtl"
//                                     name="newMessage"
//                                     value={newMessage}
//                                     onChange={(e) => setNewMessage(e.target.value)}
//                                     onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
//                                     placeholder="اكتب رسالتك..."
//                                     className="border-0 bg-transparent w-full focus:ring-0 text-gray-800 text-base font-medium px-3 placeholder-gray-500 placeholder:font-normal"
//                                 />
//                             </div>
//                         </div>
//                     </>
//                 )}

//                 {/* Invoices Tab */}
//                 {activeTab === 'invoices' && (
//                     <NegotiationInvoices
//                         negotiationId={id}
//                         invoices={invoices}
//                         isSeller={isSeller}
//                         negotiation={negotiation}
//                         onInvoiceCreated={() => {
//                             const refreshInvoices = async () => {
//                                 const invoicesRes = await axios.get(`${api_url}/invoices`, {
//                                     headers: { Authorization: `Bearer ${token}` },
//                                 });
//                                 const negotiationInvoices = invoicesRes.data.filter(
//                                     invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
//                                 );
//                                 setInvoices(negotiationInvoices);
//                             };
//                             refreshInvoices();
//                         }}
//                         onInvoiceAccepted={handleInvoiceAccepted}
//                     />
//                 )}

//                 {/* Order Tab - Pass orders array */}
//                 {activeTab === 'order' && hasOrders && (
//                     <NegotiationOrder
//                         orders={orders}
//                         negotiation={negotiation}
//                         currentUserId={currentUserId}
//                         onOrderUpdate={handleInvoiceAccepted}
//                     />
//                 )}
//             </div>

//             <InvoiceModal
//                 showInvoiceModal={showInvoiceModal}
//                 setShowInvoiceModal={setShowInvoiceModal}
//                 invoiceDetails={invoiceDetails}
//                 handleInvoiceChange={handleInvoiceChange}
//                 submitInvoice={submitInvoice}
//                 units={units}
//                 negotiation={negotiation}
//             />
//         </div>
//     );
// }

// export default NegotiationDetails;
// src/pages/me/negotiations/[id]/index.js
import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import NegotiationChatContainer from "../components/NegotiationChatContainer";
import { api_url } from "../../../../constant";
import { useParams } from "react-router-dom";
import axios from "axios";
import Client from "../../../../utils/client";
import { getUnits } from "../../../../api";
import { useQuery } from "@tanstack/react-query";
import InvoiceModal from "../components/InvoiceModal";
import { toast } from "react-toastify";
import NegotiationInvoices from "../components/NegotiationInvoices";
import { useTranslation } from "react-i18next";

function NegotiationDetails() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [messages, setMessages] = useState([]);
    const [negotiation, setNegotiation] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [sending, setSending] = useState(false);
    const [activeTab, setActiveTab] = useState('chat');
    const socket = React.useRef(null);
    const currentUserId = localStorage.getItem("user_id");
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState({
        quantity: "",
        amount: "",
        dueDate: "",
        notes: "",
        deliveryPlace: "",
        unitId: "",
        deliveryResponsibility: "seller",
        paymentTerms: "",
    });
    const [token, setToken] = useState(null);

    const { data: units } = useQuery({
        queryKey: ["units"],
        queryFn: () => getUnits(),
        cacheTime: 99999,
        staleTime: 99999,
    });

    useEffect(() => {
        const storedToken = localStorage.getItem("token")?.replace(/"/g, '');
        if (storedToken) {
            setToken(storedToken);
        }
    }, []);

    // Fetch invoices
    useEffect(() => {
        if (!id || !token) return;

        const fetchInvoices = async () => {
            try {
                const response = await axios.get(`${api_url}/invoices`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const negotiationInvoices = response.data.filter(
                    invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
                );
                setInvoices(negotiationInvoices);
            } catch (error) {
                console.error("Failed to fetch invoices:", error.message);
            }
        };

        fetchInvoices();
    }, [id, token]);

    // Main negotiation and chat setup
    useEffect(() => {
        if (!id) {
            console.error("Negotiation ID is missing");
            return;
        }

        const fetchNegotiation = async () => {
            try {
                const response = await axios.get(`${api_url}/negotiations/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setNegotiation(response.data);
            } catch (error) {
                console.error("Failed to fetch Negotiation:", error.message);
            }
        };

        const fetchMessages = async () => {
            try {
                const response = await axios.get(`${api_url}/negotiations/${id}/messages`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setMessages(response.data);
            } catch (error) {
                console.error("Failed to fetch messages:", error.message);
            }
        };

        const markMessagesAsRead = async () => {
            try {
                await Client.post(`${api_url}/messages/mark-seen/${id}`, {}, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } catch (error) {
                console.error("Failed to mark messages as read:", error.message);
            }
        };

        const IntializeSocketConnection = async () => {
            try {
                const freshToken = localStorage.getItem("token")?.replace(/"/g, '');
                if (!freshToken) {
                    console.error("Socket setup failed: token is missing");
                    return;
                }
                socket.current = io(`${api_url}/messages?negotiationId=${id}`, {
                    extraHeaders: {
                        Authorization: `Bearer ${freshToken}`,
                    },
                });

                socket.current.emit("joinRoom", `room-${id}`);

                socket.current.on("newMessage", (message) => {
                    setMessages((prev) => [...prev, message]);
                });

                socket.current.on("error", (errorMessage) => {
                    toast.error(errorMessage, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                });
            } catch (error) {
                console.error("Failed to initialize socket:", error.message);
            }
        };

        fetchNegotiation();
        fetchMessages();
        markMessagesAsRead();
        IntializeSocketConnection();

        return () => {
            if (socket.current) {
                socket.current.disconnect();
            }
        };
    }, [id, token]);

    const sendMessage = () => {
        if (newMessage.trim()) {
            setSending(true);

            socket.current.emit(
                "sendMessage",
                JSON.stringify({
                    negotiationId: parseInt(id, 10),
                    content: newMessage,
                })
            );

            setNewMessage("");
            setSending(false);
        }
    };

    const handleInvoiceChange = (e) => {
        const { name, value } = e.target;
        setInvoiceDetails((prev) => ({
            ...prev,
            [name]: name === "quantity" || name === "amount" ? Number(value) : value,
        }));
    };

    const handleIssueInvoice = () => {
        setShowInvoiceModal(true);
    };

    const submitInvoice = async () => {
        try {
            const token = localStorage.getItem("token");

            const formattedNegotiationId = Number(id);
            const formattedQuantity = Number(invoiceDetails.quantity);
            const formattedAmount = Number(invoiceDetails.amount);
            const formattedUnitId = Number(invoiceDetails.unitId);

            if (isNaN(formattedNegotiationId) || isNaN(formattedQuantity) || isNaN(formattedAmount)) {
                toast.error(t("negotiation.invoice.invalidData"));
                return;
            }

            const checkResponse = await axios.get(`${api_url}/invoices/${formattedNegotiationId}/pending`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (checkResponse.data.hasPendingInvoice) {
                toast.error(t("negotiation.invoice.pendingExists"));
                return;
            }

            await axios.post(
                `${api_url}/invoices`,
                {
                    negotiationId: formattedNegotiationId,
                    quantity: invoiceDetails.quantity,
                    amount: formattedAmount,
                    dueDate: invoiceDetails.dueDate,
                    notes: invoiceDetails.notes,
                    deliveryPlace: invoiceDetails.deliveryPlace,
                    unitId: formattedUnitId,
                    deliveryResponsibility: invoiceDetails.deliveryResponsibility,
                    paymentTerms: invoiceDetails.paymentTerms,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            toast.success(t("negotiation.invoice.success"));
            setShowInvoiceModal(false);

            const invoicesRes = await axios.get(`${api_url}/invoices`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const negotiationInvoices = invoicesRes.data.filter(
                invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
            );
            setInvoices(negotiationInvoices);

        } catch (error) {
            console.error("Failed to submit invoice:", error.response?.data || error.message);
            toast.error(t("negotiation.invoice.failed"));
        }
    };

    const handleInvoiceAccepted = async () => {
        const invoicesRes = await axios.get(`${api_url}/invoices`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        const negotiationInvoices = invoicesRes.data.filter(
            invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
        );
        setInvoices(negotiationInvoices);
    };

    if (!negotiation) {
        return (
            <div className="flex justify-center items-center h-96">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        );
    }

    const isSeller = currentUserId === negotiation?.sellerId;
    const hasPendingInvoice = invoices.some(inv => inv.status === 'pending');
    const counterpartyName = currentUserId === negotiation?.buyerId 
        ? negotiation?.seller?.name 
        : negotiation?.buyer?.name;

    return (
        <div className="w-full h-full relative mt-10">
            <div className="mx-auto lg:w-[66%]">
                {/* Header Card */}
                <div className="text-center lg:border-2 border-primary rounded-t-2xl py-4 px-6 lg:px-10 bg-white shadow-lg">
                    <div className="lg:pb-6 pb-4 flex-wrap flex gap-4 items-center justify-center lg:justify-between border-b-2 border-primary">
                        {currentUserId === negotiation?.sellerId && !hasPendingInvoice && (
                            <button
                                onClick={handleIssueInvoice}
                                className="bg-primary text-white p-2 px-3 font-bold text-sm rounded-lg hover:scale-105 transition cursor-pointer"
                            >
                                {t("negotiation.buttons.issueInvoice")}
                            </button>
                        )}

                        {negotiation?.itemName ? (
                            <p className="text-2xl font-bold md:block hidden">
                                {negotiation.type === "SERVICE" ? "" : (`${negotiation.quantity} `)}
                                {negotiation.itemUnit}&nbsp;
                                - &nbsp;
                                {negotiation.itemName}
                            </p>
                        ) : (
                            <p>{t("common.loading")}</p>
                        )}

                        <div className="flex justify-center lg:justify-end items-center gap-1">
                            <span className="relative font-bold text-sm rounded-lg px-4 py-2 shadow-lg shadow-green-500/30 border border-primary flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-green-500 shadow-lg shadow-green-500/30"></span>
                                {counterpartyName || (currentUserId === negotiation?.buyerId ? t("common.seller") : t("common.buyer"))}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Tabs - Separate from chat frame */}
                <div className="mt-4 px-2">
                    <div className="flex gap-2 p-1 bg-gray-100 rounded-xl">
                        <button
                            onClick={() => setActiveTab('chat')}
                            className={`
                                flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-medium transition-all duration-200
                                ${activeTab === 'chat'
                                    ? 'bg-primary text-white shadow-md'
                                    : 'text-gray-600 hover:bg-gray-200'
                                }
                            `}
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                            </svg>
                            <span>{t("negotiation.tabs.chat")}</span>
                        </button>
                        
                        <button
                            onClick={() => setActiveTab('invoices')}
                            className={`
                                flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-medium transition-all duration-200
                                ${activeTab === 'invoices'
                                    ? 'bg-primary text-white shadow-md'
                                    : 'text-gray-600 hover:bg-gray-200'
                                }
                            `}
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            <span>{t("negotiation.tabs.invoices")}</span>
                            {invoices.length > 0 && (
                                <span className={`px-2 py-0.5 rounded-full text-xs ${
                                    activeTab === 'invoices' 
                                        ? 'bg-white text-primary' 
                                        : 'bg-gray-200 text-gray-600'
                                }`}>
                                    {invoices.length}
                                </span>
                            )}
                        </button>
                    </div>
                </div>

                {/* Content Area */}
                <div className="mt-4">
                    {/* Chat Tab Content */}
                    {activeTab === 'chat' && (
                        <div className="bg-white rounded-b-2xl shadow-lg overflow-hidden">
                            <NegotiationChatContainer
                                messages={messages}
                                currentUserId={currentUserId}
                                negotiation={negotiation}
                            />
                            <div className="relative w-full p-4 border-t border-gray-200">
                                <div className="h-16 border border-primary rounded-2xl flex items-center px-3 lg:px-6 bg-white">
                                    <button
                                        onClick={sendMessage}
                                        disabled={sending || !newMessage}
                                        className={`
                                            flex items-center justify-center px-4 py-2 text-white font-bold text-lg
                                            rounded-xl transition-all duration-200
                                            ${sending || !newMessage ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary hover:bg-primary-dark'}
                                        `}
                                    >
                                        {t("negotiation.chat.send")}
                                    </button>
                                    <input
                                        type="text"
                                        dir="rtl"
                                        name="newMessage"
                                        value={newMessage}
                                        onChange={(e) => setNewMessage(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                                        placeholder={t("negotiation.chat.placeholder")}
                                        className="border-0 bg-transparent w-full focus:ring-0 text-gray-800 text-base font-medium px-3 placeholder-gray-500 placeholder:font-normal"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Invoices Tab Content */}
                    {activeTab === 'invoices' && (
                        <div className="bg-white rounded-b-2xl shadow-lg p-6">
                            <NegotiationInvoices
                                negotiationId={id}
                                invoices={invoices}
                                isSeller={isSeller}
                                negotiation={negotiation}
                                onInvoiceCreated={() => {
                                    const refreshInvoices = async () => {
                                        const invoicesRes = await axios.get(`${api_url}/invoices`, {
                                            headers: { Authorization: `Bearer ${token}` },
                                        });
                                        const negotiationInvoices = invoicesRes.data.filter(
                                            invoice => invoice.negotiation?.id === parseInt(id) || invoice.negotiationId === parseInt(id)
                                        );
                                        setInvoices(negotiationInvoices);
                                    };
                                    refreshInvoices();
                                }}
                                onInvoiceAccepted={handleInvoiceAccepted}
                            />
                        </div>
                    )}
                </div>
            </div>

            <InvoiceModal
                showInvoiceModal={showInvoiceModal}
                setShowInvoiceModal={setShowInvoiceModal}
                invoiceDetails={invoiceDetails}
                handleInvoiceChange={handleInvoiceChange}
                submitInvoice={submitInvoice}
                units={units}
                negotiation={negotiation}
            />
        </div>
    );
}

export default NegotiationDetails;